// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicHomepage } from "./plasmic/o_21_p_nexus_2_4_2_prod/PlasmicHomepage";
import { Helmet } from "react-helmet-async" ;
function Homepage_(props, ref) {
  
  //return <PlasmicHomepage pageHome={{ ref }} {...props} />;
  return(

    <>
    <Helmet>
      <title>o21p | nexus</title>

      <meta name="og:title" content="o21p | nexus" />
      <meta name="og:description" content="A space for independent experts and agencies to present who they are, showcase what they do, and become part of the o21p network." />
      <meta name="og:url" content="https://nexus.o21p.com/" />

      <meta name="description" content="A space for independent experts and agencies to present who they are, showcase what they do, and become part of the o21p network." />
      <link rel="icon" type="image/x-icon" href="%PUBLIC_URL%/tab-icon-48px.png" />
      <link rel="icon" type="image/png"  href="%PUBLIC_URL%/favicon2.ico" />
        <link rel="shortcut icon" href="%PUBLIC_URL%/favicon.ico" type="image/x-icon" />
        <link rel="apple-touch-icon" href="%PUBLIC_URL%/apple-touch-icon.png" />
        <link rel="apple-touch-icon" sizes="57x57" href="%PUBLIC_URL%/apple-touch-icon-57x57.png" />
        <link rel="apple-touch-icon" sizes="72x72" href="%PUBLIC_URL%/apple-touch-icon-72x72.png" />
        <link rel="apple-touch-icon" sizes="76x76" href="%PUBLIC_URL%/apple-touch-icon-76x76.png" />
        <link rel="apple-touch-icon" sizes="114x114" href="%PUBLIC_URL%/apple-touch-icon-114x114.png" />
        <link rel="apple-touch-icon" sizes="120x120" href="%PUBLIC_URL%/apple-touch-icon-120x120.png" />
        <link rel="apple-touch-icon" sizes="144x144" href="%PUBLIC_URL%/apple-touch-icon-144x144.png" />
        <link rel="apple-touch-icon" sizes="152x152" href="%PUBLIC_URL%/apple-touch-icon-152x152.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="%PUBLIC_URL%/apple-touch-icon-180x180.png" />
    </Helmet>
    <PlasmicHomepage pageHome={{ ref }} {...props} />
    </>
  )
}


const Homepage = React.forwardRef(Homepage_);

export default Homepage;
